/**
 * @file EULAPage.js
 * @description This file contains the EULAPage component, which allows users to review and agree to the Terms of Use.
 */
import { useState } from 'react';
import {
    createAgencyOffice,
    updateAgencyOffice,
} from '../../services/systemService';
import styles from '../population-groups/PopulationGroup.module.scss';
import { SecurityAttributes } from '../../utils/data/enums';
import { useAuthContext } from '../../store/AuthContext';
import Toast from '../ui/toasts/Toast';
import { getText } from '../../i18n';

const LocationsForm = ({
    currentName,
    currentCode,
    isActive = true,
    locationId = 0,
    agencyId,
    onSave,
    onCancel,
}) => {
    const [newName, setNewName] = useState(currentName);
    const [newCode, setNewCode] = useState(currentCode);
    const { hasAttribute } = useAuthContext();

    const canEditForm = hasAttribute(SecurityAttributes.AgencyFullAccess);

    const saveLocation = async () => {
        try {
            if (locationId === 0) {
                await createAgencyOffice({
                    AgencyId: parseInt(agencyId),
                    Name: newName.trim(),
                    Code: newCode.trim(),
                    IsActive: isActive,
                });
            } else {
                await updateAgencyOffice({
                    Id: locationId,
                    AgencyId: parseInt(agencyId),
                    Name: newName.trim(),
                    Code: newCode.trim(),
                    IsActive: isActive,
                });
            }

            Toast.success(getText('msg_72fa4870323b'));
            onSave();
        } catch (error) {
            console.error('Error creating Location:', error);
            if (error?.response?.data?.detail) {
                Toast.error(error.response.data.detail);
            } else {
                Toast.error(getText('msg_667031a203b3'));
            }
        }
    };

    const close = () => {
        onCancel(true);
    };

    return (
        <div className="card-body px-0">
            {/*
             *
             * Begin form body
             *
             */}
            <form
                className={`form-container p-3 ${styles.groupForm}`}
                style={{ width: '567px', margin: 'auto' }}
            >
                <div className={`form-group mb-3`}>
                    <label htmlFor="groupName">
                        {getText('msg_709a23220f2c')} <span className="text-danger">*</span>
                    </label>
                    <input
                        onChange={event => {
                            setNewName(event.target.value);
                        }}
                        maxLength="128"
                        className={`form-control ${styles.nameClassName}`}
                        defaultValue={newName}
                        placeholder={getText('msg_56964ab5f0c4')}
                        autoFocus
                    />
                </div>
                <div className={`form-group mb-3`}>
                    <label htmlFor="groupName">
                        {getText('msg_adac69379a62')} <span className="text-danger">*</span>
                    </label>
                    <input
                        onChange={event => {
                            setNewCode(event.target.value);
                        }}
                        maxLength="128"
                        className={`form-control ${styles.nameClassName}`}
                        defaultValue={newCode}
                        placeholder={getText('msg_c2b5864d6bbc')}
                    />
                </div>
            </form>
            {/*
             *
             * End form body
             *
             */}
            <div className="d-flex justify-content-center mb-5 me-4">
                <p
                    type="button"
                    onClick={close}
                    className="ing-popup-blue-negative submit-button-form mx-5"
                >
                    <i className="bi bi-x me-2" />
                    {getText('msg_77dfd2135f4d')}
                </p>
                {canEditForm && (
                    <p
                        type="button"
                        onClick={saveLocation}
                        className="mx-5 ing-button-primary-left align-self-baseline"
                    >
                        <i className="bi bi-check-lg me-2" />
                        {getText('msg_efc007a393f6')}
                    </p>
                )}
            </div>
        </div>
    );
};

export default LocationsForm;
